import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el libro?',
  answer: 'Inmediatamente después del pago recibirás un enlace de descarga. Es un PDF que podés leer en cualquier dispositivo.'
}, {
  question: '¿Sirve si mi pareja no quiere participar?',
  answer: 'Sí. El manual incluye una sección para aplicar cambios unilaterales que generan un impacto positivo en el vínculo.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí. Pagás una sola vez y tenés acceso de por vida al material. Sin suscripciones ni costos ocultos.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Si el contenido no te aporta valor, tenés 7 días para pedir la devolución total. Sin preguntas.'
}];
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#FAF7F2]" data-id="element-39">
      <div className="max-w-3xl mx-auto px-6" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-41">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4B5A] mb-16 text-center font-serif" data-id="element-42">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-43">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className="bg-white rounded-2xl overflow-hidden border border-[#E8E0D4] shadow-sm" data-id="element-44">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#FAF7F2]/50 transition-colors" data-id="element-45">
                  <span className="text-lg font-semibold text-[#2C2C2C] pr-4 font-sans" data-id="element-46">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-47">
                    <ChevronDownIcon className="w-5 h-5 text-[#1B4B5A] flex-shrink-0" data-id="element-48" />
                  </motion.div>
                </button>
                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-49">
                  <div className="px-8 pb-6 text-[#7A7A6E] leading-relaxed font-sans" data-id="element-50">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}